export default el => transform => {
  if (transform !== false) $(el).css({
    transform,
    webkitTransform: transform,
    mozTransform: transform,
    msTransform: transform
  })
}